import '~/entrypoints/config/init';

import Vue from 'vue';
import VueGoogleMaps from '~/google_maps';
// TODO: Once we have Vue 3, we will have to use `@inertiajs/inertia-vue3`
import { createInertiaApp, Link } from '@inertiajs/inertia-vue';

import HubApp from '../plugins/hub_app';

Vue.mixin({
  beforeDestroy() {
    // Clean up any teleported elements
    const teleportTarget = document.getElementById('teleport-target');

    if (teleportTarget) {
      teleportTarget.innerHTML = '';
    }
  }
});

// Eagerly load the pages so that Vite can analyse the dynamic imports.
// We use eager loading here because for now we want to avoid having
// to load as many chunks as possible in the browser.
//
// This will essentially create an object with the following structure:
// ```
// import * as __glob_0_0 from './WorkOrderes/Index.vue';
// import * as __glob_0_1 from './WorkOrderes/Show.vue';
// const PAGES_MAP = {
//   '../pages/WorkOrders/Index.vue': __glob_0_0,
//   '../pages/WorkOrders/Show.vue': __glob_0_1,
// }
// ```
// FIXME: Remove the negative pattern once we've migrated to fullcalendar v5
const PAGES_MAP = import.meta.glob(['../pages/**/*.vue'], { eager: true });

// The actual setup from the documentation doesn't work
// and we have to use this work around in our setup.
// See:
// - [Client setup](https://inertiajs.com/client-side-setup)
// - [Server setup](https://inertiajs.com/server-side-setup)
//
// Do not fail if we're not using Inertia in "this page"
if (document.querySelector('#app')) {
  createInertiaApp({
    resolve: (pagePath) => {
      const page = PAGES_MAP[`../pages/${pagePath}.vue`];

      if (!page) {
        throw new Error(`Page not found: ${page}`);
      }

      return typeof page === 'function' ? page() : page;
    },
    setup({ el, app, props, plugin }) {
      // Add the `App[Component]`s, directives & filters
      Vue.use(HubApp);
      Vue.use(plugin);

      // Add the Intertiajs `Link` as a global component
      // so that we improve DX ergonomics.
      Vue.component('InertiaLink', Link);

      // Initialize Google Maps if needed
      // TODO: Change this to `import` when we update ESLint
      const {
        props: {
          initialPage: { props: pageProps },
        },
      } = props;

      if (pageProps.googleMapsKey || pageProps.google_maps_key) {
        Vue.use(VueGoogleMaps, pageProps.googleMapsKey || pageProps.google_maps_key);
      }

      new Vue({
        name: 'InertiaRoot',
        render: (createElement) => createElement(app, props),
      }).$mount(el);
    },
  });
}
